import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
// import './App.css'
import FirstPage from './FirstPage';

import 'bootstrap/dist/css/bootstrap.min.css';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FirstPage />
  </React.StrictMode>
);
